import React from "react";
import styled from "styled-components";
import cardBg from "../../../assets/images/program-card-bg.svg";
// import pic3 from "../../../assets/images/live-class-icon3.svg";
import pic3 from "../../../assets/images/upcoming-pic.svg";

export default function UpcomingWebinar() {
    return (
        <MainContainer>
            <PathText>
                webinars <PathTextBlack>/ Upcoming</PathTextBlack>
            </PathText>
            <ContentWrapper>
                {/* <Image src={} alt="images" /> */}
                <MainDiv
                    style={{
                        backgroundImage: `url(${pic3})`,
                    }}
                >
                    <ContentBox>
                        <TopPart></TopPart>
                        <BottomPart>
                            <LeftPart>
                                <Title>Mathemathics</Title>
                                <SubTitle>Trignometric Functions</SubTitle>
                            </LeftPart>
                            <RightPart>
                                <Button>Remind Me</Button>
                            </RightPart>
                        </BottomPart>
                    </ContentBox>
                </MainDiv>
                <AboutTitle>About Webinar</AboutTitle>
                <Para>
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia, looked up one of the more obscure Latin words,
                    consectetur, from a Lorem Ipsum passage, and going through
                    the cites of the word in classical literature, discovered
                    the undoubtable source. Lorem Ipsum comes from sections
                    1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The
                    Extremes of Good and Evil) by Cicero, written in 45 BC. This
                    book is a treatise on the theory of ethics, very popular
                    during the Renaissance. The first line of Lorem Ipsum,
                    "Lorem ipsum dolor sit amet..", comes from a line in section
                    1.10.32. The standard chunk of Lorem Ipsum used since the
                    1500s is reproduced below for those interested. Sections
                    1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by
                    Cicero are also reproduced in their exact original form,
                    accompanied by English versions from the 1914 translation by
                    H. Rackham. Contrary to popular belief, Lorem Ipsum is not
                    simply random text. It has roots in a piece of classical
                    Latin literature from 45 BC, making it over 2000 years old.
                    Richard McClintock, a Latin professor at Hampden-Sydney
                    College in Virginia, looked up one of the more obscure Latin
                    words, consectetur, from a Lorem Ipsum passage, and going
                    through the cites of the word in classical literature,
                    discovered the undoubtable source. Lorem Ipsum comes from
                    sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et
                    Malorum" (The Extremes of Good and Evil) by Cicero, written
                    in 45 BC. This book is a treatise on the theory of ethics,
                    very popular during the Renaissance. The first line of Lorem
                    Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
                    section 1.10.32. The standard chunk of Lorem Ipsum used
                    since the 1500s is reproduced below for those interested.
                    Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et
                    Malorum" by Cicero are also reproduced in their exact
                    original form, accompanied by English versions from the 1914
                    translation by H. Rackham.
                </Para>
            </ContentWrapper>
        </MainContainer>
    );
}

const MainContainer = styled.div`
    background: #ffffff;
    padding: 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    border-radius: 10px;
    height: calc(100vh - 110px);
    overflow-y: scroll;
`;
const PathText = styled.span`
    display: inline-block;
    font-size: 14px;
    color: #9d9d9d;
    margin-bottom: 30px;
`;
const PathTextBlack = styled.span`
    color: #000;
`;
const ContentWrapper = styled.div``;
const MainDiv = styled.div`
    height: 400px;
    width: 600px;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    float: left;
    margin-right: 12px;
    margin-bottom: 2px;
    @media (max-width: 1500px) {
        width: 500px;
    }
    @media (max-width: 1280px) {
        width: 450px;
        height: 360px;
    }
    @media (max-width: 1180px) {
        width: 550px;
    }
    @media (max-width: 1080px) {
        width: 450px;
        height: 360px;
    }
    @media (max-width: 880px) {
        width: 400px;
    }
`;

const ContentBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;
const TopPart = styled.div`
    display: flex;
    align-items: center;
    padding: 20px;
`;
const BottomPart = styled.div`
    background: linear-gradient(
        360deg,
        #000000 17.23%,
        rgba(0, 0, 0, 0) 98.73%
    );
    border-radius: 0px 0px 16px 16px;
    /* height: 120px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px;
`;
const LeftPart = styled.div``;
const Title = styled.h6`
    font-size: 1rem;
    color: #fff;
`;
const SubTitle = styled.h6`
    font-size: 1.15rem;
    color: #fff;
    font-weight: 600;
    margin-top: 8px;
`;
const RightPart = styled.div``;
const Button = styled.div`
    padding: 12px 25px;
    background: #917afd;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        /* box-shadow: 0 0.5em 0.5em -0.4em var(--hover); */
        transform: translateY(-0.1em);
        /* transform: scale(1.01); */
    }
`;
const AboutTitle = styled.h6`
    color: #010101;
    font-size: 1.1rem;
    font-weight: 500;
    margin-bottom: 20px;
`;
const Para = styled.p`
    color: #9d9d9d;
    font-size: 0.9rem;
`;

// const MainDiv = styled.div``;
// const MainDiv = styled.div``;
// const MainDiv = styled.div``;
// const MainDiv = styled.div``;
// const MainDiv = styled.div``;
// const MainDiv = styled.div``;
